import styled from 'styled-components'

export const Section = styled.div`
	margin: 24px 0;
`
